import { Component, OnInit, Input, Output, EventEmitter, HostListener } from '@angular/core';

import { Tooltip } from 'src/app/model/tooltip';
import { ViewChild } from '@angular/core';
import { ElementRef } from '@angular/core';
import { SERVICE_END_POINT, UtilService } from 'src/app/shared';
import { Router } from '@angular/router';
import { MEDICAL_UW_URL, UW_WEB_ANALYTICS_CONST } from 'src/app/shared/constants/medical-uw-url.constants';
import { LifeStyleQuestion } from 'src/app/pages/medical-underwriting/model';
import { DeviceDimensionsService } from 'src/app/shared/utilities/functionality/device-dimensions.service';
import { NgClass } from '@angular/common';
@Component({
    selector: 'app-tool-tip-notification',
    templateUrl: './tool-tip-notification.component.html',
    styleUrls: ['./tool-tip-notification.component.scss'],
    imports: [NgClass]
})
export class ToolTipNotificationComponent implements OnInit {

  @Input() tooltipData: Tooltip;
  @Input() childId: string;
  @Input() tooltipName: string;
  // tslint:disable-next-line:no-inferrable-types
  @Input() disable: boolean = false;
  @Output() goToDependatsTTEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Input() prodCode: string;
  @Input() uwQuesForWA: LifeStyleQuestion;

  /** for web tracking */
  @Output() letterPackInfoEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() pensionWiseInfoEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() dobInfoEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() UKResidentInfoEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() contractCodeEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() GACodeEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() totalPensionPotEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() dependentContinueToPayInfoEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() qualifyingDependentInfoEmitter: EventEmitter<any> = new EventEmitter<any>();

  @Output() riskTaxEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() riskInflationEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() riskLongTermCareEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() riskDebtMgmtEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() riskOverallReturnEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() consentEmitter: EventEmitter<any> = new EventEmitter<any>();

  @Output() lifetimeAllowanceEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() pensionCreditEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() benefitGuaranteedEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() lifestyleInfoEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() medCondnInfoEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() lifestyleHealthRiskInfoEmitter: EventEmitter<any> = new EventEmitter<any>();

  @Output() lumpSumAllowanceEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() lsaProtectionEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() displayMobileTooltipEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() displayCorpMobileTooltipEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() displayFtrpMobileTooltipEmitter: EventEmitter<any> = new EventEmitter<any>();


  public iconName = '';
  public isTooltipOpen = false;
  tooltipRight: boolean;
  // tslint:disable-next-line:no-inferrable-types
  tooltip1024: boolean = false;
  private infoOpenUrl;
  private infoCloseUrl;
  private CMSData;
  deviceType: any;
  
  @ViewChild("blurTooltip", { static: true }) toolTipBtn: ElementRef;

  constructor(private utilService: UtilService, 
    private router: Router, 
    private deviceDimensionsService: DeviceDimensionsService) { }

  ngOnInit() {
    this.GetCMSDataServiceMapper();
    this.detectScreenSize();
  }

  @HostListener('window:resize', [])
  public onResize() {
    this.detectScreenSize();
  }
  private detectScreenSize() {
    this.deviceType=this.deviceDimensionsService.onResize('$event');
  }

  toggleHandler(e) {
    if (!this.disable || (this.disable && this.tooltipData.disabledInfoIconTextVisibility)) {
      this.isTooltipOpen = !this.isTooltipOpen;
      // tslint:disable-next-line:max-line-length
      this.iconName = this.isTooltipOpen ? '_Close' : '';
      this.findOffset(e);
      if (this.tooltipRight === true) {
        this.getScreenResolution();
      }
      /** Web Analytics section */
      if (this.uwQuesForWA) { // it runs only for BRMS dynamic values
        this.lifestyleInfoEmitter.emit(this.uwQuesForWA);        
      }
      else { // it runs fo all static values
        this.lifestyleHealthRiskInfoEmitter.emit(UW_WEB_ANALYTICS_CONST.healthRisk);
        this.letterPackInfoEmitter.emit('Warm up pack info');
        this.pensionWiseInfoEmitter.emit('Pension Wise info');
        this.dobInfoEmitter.emit('Date of birth info');
        this.UKResidentInfoEmitter.emit('UK resident info');
        this.contractCodeEmitter.emit('Contract code');
        this.GACodeEmitter.emit('GA code');
        this.totalPensionPotEmitter.emit('Total pension pot');
        this.dependentContinueToPayInfoEmitter.emit('Continue to pay');
        this.qualifyingDependentInfoEmitter.emit('Add qualifying dependant');
        this.riskTaxEmitter.emit('how much tax you\'ll pay');
        this.riskInflationEmitter.emit('Have you considered inflation');
        this.riskLongTermCareEmitter.emit('means tested benefits');
        this.riskDebtMgmtEmitter.emit('credit cards and loans');
        this.riskOverallReturnEmitter.emit('Risk - overall return');
        this.consentEmitter.emit('consent');
        this.lifetimeAllowanceEmitter.emit('Lifetime allowance');
        this.pensionCreditEmitter.emit('Pension credit');
        this.benefitGuaranteedEmitter.emit('Benefit guaranteed');
        this.medCondnInfoEmitter.emit('Medical conditions info');
        this.lumpSumAllowanceEmitter.emit('Lump Sum allowance');
        this.lsaProtectionEmitter.emit('Protection')
      }
    }
  }


  findOffset = (ev) => {
    const mousex = ev.pageX + 20; // Get X coordinates
    const mousey = ev.pageY + 10; // Get Y coordinates
    if ((mousex + 350) > window.innerWidth) {
      this.tooltipRight = true;

    } else {
      this.tooltipRight = false;
    }
  }

  getScreenResolution() {
    let x = window.screen.availWidth;
    let y = window.screen.availHeight;

    if (x === 1024 && y === 768) {
      this.tooltip1024 = true;
    }

    let w = window.screen.width;
    let h = window.screen.height;

    if (w === 1024 && h === 768) {
      this.tooltip1024 = true;
    }

  }

  getToolTipName(strName) {
    let s: string;
    if (strName === 'InformationConfig') {
      s = strName.replace('InformationConfig', '');
      return s;
    }
    return strName;

  }
  /** Code block for tooltip content alignment */
  getUwUrl() {
    if ((Object.values(MEDICAL_UW_URL.annuitant).indexOf(this.router.url) > -1) || (Object.values(MEDICAL_UW_URL.dependant).indexOf(this.router.url))) {
      return true;
    } else {
      return false;
    }
  }
  /** End of code block for tooltip content alignment */
  blurHandler() {
    this.toolTipBtn.nativeElement.blur();
  }

  goToDependantsPageTT() {
    this.goToDependatsTTEmitter.emit();
  }
  /** Code block for CMS */
  GetCMSDataServiceMapper() {
    const URL = SERVICE_END_POINT.higherEnvironment.CMS_YourProductQuote;
    this.utilService.getCMSData(URL).subscribe(res => {
      this.CMSData = res;
      if (this.CMSData) {
        /** In the line below we are over-writing the contentData object values with CMSData object values */
        this.infoOpenUrl = this.CMSData.commonBlock.imageUrl_InformationIcon;
        this.infoCloseUrl = this.CMSData.commonBlock.imageUrl_InformationIconClose;

      }
    });
  }

  displayMobileTooltip(){
    this.displayMobileTooltipEmitter.emit();
    this.displayCorpMobileTooltipEmitter.emit();
    this.displayFtrpMobileTooltipEmitter.emit();
    this.medCondnInfoEmitter.emit();
  }
  
  /** End of code block for CMS */
}
